import React from 'react';
import { SortButton } from '../../../../search/components/sort';
import { SearchProps } from '../../models/arc-epi-props';



interface DioceseListLabelsProps {
	settings: SearchProps,
}

export const DioceseListLabels = (props: DioceseListLabelsProps) => {

	return (
		<div className='sort-table-row'>
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.dioceseIdLabel} name='client_number' />
			</div>
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.dioceseNameLabel} name='diocese' />
			</div>
		</div>
	);

};